<template>

    <div class="p-grid" id="client_dashboard">
        <div class="p-col-12">
            <div class="card">
                <h4 class="p-d-flex p-ai-baseline p-jc-between" style="width: 100%; margin-bottom: 2rem;">
                    <span>
                        <router-link v-if="APICallback.client && APICallback.client.key" :to="{ name: 'sites', params: { id: APICallback.client.key } }">
                            {{ APICallback.client.name }}
                        </router-link>
                        / Dashboard
                    </span>
                </h4>
                <div class="chart_filter">
                    <MultiSelect v-model="selectedSites" @before-hide="initGraphs" :options="APICallback.sites" :filter="true" optionLabel="name" placeholder="Select Sites" class="p-mb-2 p-mt-2" style="width: 30rem;" />
                    <h4 style="width: 50%; display: inline-block; text-align: right;">Total Assets - {{
                        assetCountLifecycle }}</h4>
                </div>

                <div class="dashboard_cards" style="gap: 2rem; margin: 0; margin-bottom: 2rem;">

                    <Card class="entry_card graph_card">
                        <template #title>
                            Asset Maintenance Schedule
                        </template>

                        <template #content>
                            <div v-if="loader" class="loader_wrapper">
                                <i class="pi pi-spin pi-spinner loader" style="font-size: 4rem"></i>
                            </div>
                            <canvas id="AssetMaintenanceStatus"></canvas>
                        </template>

                        <template #footer>
                            <Button :disabled="loading && selectedExport == 'asset_maintenance_schedule'" :label="loading && selectedExport == 'asset_maintenance_schedule' ? 'Downloading Report...' : 'Download Report'" :icon="loading && selectedExport == 'asset_maintenance_schedule' ? 'pi pi-spin pi-spinner' : 'pi pi-angle-right'" iconPos="right" @click.prevent="sendReportVisible = true, selectedExport = 'asset_maintenance_schedule'" />
                        </template>
                    </Card>

                    <Card class="entry_card graph_card">
                        <template #title>
                            Location Attendance Schedule
                        </template>

                        <template #content>
                            <div v-if="loader" class="loader_wrapper">
                                <i class="pi pi-spin pi-spinner loader" style="font-size: 4rem"></i>
                            </div>
                            <canvas id="LocationAttendanceSchedule"></canvas>
                        </template>

                        <template #footer>
                            <Button :disabled="loading && selectedExport == 'location_attendance_schedule'" :label="loading && selectedExport == 'location_attendance_schedule' ? 'Downloading Report...' : 'Download Report'" :icon="loading && selectedExport == 'location_attendance_schedule' ? 'pi pi-spin pi-spinner' : 'pi pi-angle-right'" iconPos="right" @click.prevent="sendReportVisible = true, selectedExport = 'location_attendance_schedule'" />
                        </template>
                    </Card>

                    <Card class="entry_card graph_card">
                        <template #title>
                            Asset/Location Maintenance Status
                        </template>

                        <template #content>
                            <div v-if="loader" class="loader_wrapper">
                                <i class="pi pi-spin pi-spinner loader" style="font-size: 4rem"></i>
                            </div>
                            <canvas id="AssetLocationMaintenanceStatus"></canvas>
                        </template>

                        <template #footer>
                            <Button :disabled="loading && selectedExport == 'asset_location_maintenance_status'" :label="loading && selectedExport == 'asset_location_maintenance_status' ? 'Downloading Report...' : 'Download Report'" :icon="loading && selectedExport == 'asset_location_maintenance_status' ? 'pi pi-spin pi-spinner' : 'pi pi-angle-right'" iconPos="right" @click.prevent="sendReportVisible = true, selectedExport = 'asset_location_maintenance_status'" />
                        </template>
                    </Card>

                    <Card class="entry_card graph_card">

                        <template #title>
                            Asset/Location Fault Report Status
                        </template>

                        <template #content>
                            <div v-if="faultLoader" class="loader_wrapper">
                                <i class="pi pi-spin pi-spinner loader" style="font-size: 4rem"></i>
                            </div>
                            <canvas id="FaultStatus"></canvas>
                        </template>

                        <template #footer>
                            <Button :disabled="loading && selectedExport == 'asset_location_fault_report_status'" :label="loading && selectedExport == 'asset_location_fault_report_status' ? 'Downloading Report...' : 'Download Report'" :icon="loading && selectedExport == 'asset_location_fault_report_status' ? 'pi pi-spin pi-spinner' : 'pi pi-angle-right'" iconPos="right" @click.prevent="sendReportVisible = true, selectedExport = 'asset_location_fault_report_status'" />
                        </template>
                    </Card>

                    <Card class="entry_card graph_card">

                        <template #title>
                            Asset Warranty Status
                        </template>

                        <template #content>
                            <div v-if="loader" class="loader_wrapper">
                                <i class="pi pi-spin pi-spinner loader" style="font-size: 4rem"></i>
                            </div>
                            <canvas id="AssetWarrantyStatus"></canvas>
                        </template>

                        <template #footer>
                            <Button :disabled="loading && selectedExport == 'asset_warranty_status'" :label="loading && selectedExport == 'asset_warranty_status' ? 'Downloading Report...' : 'Download Report'" :icon="loading && selectedExport == 'asset_warranty_status' ? 'pi pi-spin pi-spinner' : 'pi pi-angle-right'" iconPos="right" @click.prevent="sendReportVisible = true, selectedExport = 'asset_warranty_status'" />
                        </template>
                    </Card>

                    <Card class="entry_card graph_card">

                        <template #title>
                            Asset Lifecycle Status
                        </template>

                        <template #content>
                            <div v-if="loader" class="loader_wrapper">
                                <i class="pi pi-spin pi-spinner loader" style="font-size: 4rem"></i>
                            </div>
                            <canvas id="AssetLifecycle"></canvas>
                        </template>

                        <template #footer>
                            <Button :disabled="loading && selectedExport == 'asset_lifecycle_status'" :label="loading && selectedExport == 'asset_lifecycle_status' ? 'Downloading Report...' : 'Download Report'" :icon="loading && selectedExport == 'asset_lifecycle_status' ? 'pi pi-spin pi-spinner' : 'pi pi-angle-right'" iconPos="right" @click.prevent="sendReportVisible = true, selectedExport = 'asset_lifecycle_status'" />
                        </template>
                    </Card>
                </div>
                <Accordion class="p-mb-4">
                    <AccordionTab header="Attendance Log">
                        <Card class="entry_card card_with_table attendance_card">
                            <template #content>
                                <DataTable :value="APICallback.attendanceData" class="" tableStyle="min-width: 50rem" :filters="filters" paginator :rows="5" sortField="timestamp._seconds" :sortOrder="-1">
                                    <template #header>
                                        <div class="p-d-md-flex p-jc-md-between p-ai-center">
                                            <div>
                                                <span class="p-input-icon-left p-mt-2 p-ml-md-2">
                                                    <i class="pi pi-search" />
                                                    <InputText v-model="filters['global'].value" placeholder="Attendance Search" />
                                                </span>
                                            </div>
                                        </div>
                                    </template>
                                    <Column field="full_name" header="Full Name"></Column>
                                    <Column field="company" header="Company"></Column>
                                    <Column field="site_name" header="Site"></Column>
                                    <Column field="timestamp._seconds" header="Date/Time" :sortable="true">

                                        <template #body="slotProps">
                                            {{ slotProps.data.datetime }}
                                        </template>
                                    </Column>
                                    <Column field="checked.value" header="Check Status">

                                        <template #body="slotProps">
                                            {{ slotProps.data.checked.name }}
                                        </template>
                                    </Column>
                                </DataTable>
                            </template>
                        </Card>
                    </AccordionTab>
                </Accordion>


                <Accordion>
                    <AccordionTab header="Management Activity Log">
                        <DataTable :value="logs" class="p-datatable-customers" :rows="limit" dataKey="id" :loading="false">

                            <template #empty>
                                No logs found.
                            </template>

                            <template #loading>
                                Loading activity data. Please wait.
                            </template>
                            <Column field="timestamp" header="When" :sortable="true">

                                <template #body="slotProps">
                                    {{ format_date(slotProps.data.timestamp._seconds * 1000) }}
                                </template>
                            </Column>
                            <Column field="user" header="User" :sortable="true">

                                <template #body="slotProps">
                                    {{ slotProps.data.user }}
                                </template>
                            </Column>
                            <Column field="activity" header="Activity" :sortable="true">

                                <template #body="slotProps">
                                    {{ slotProps.data.activity }}
                                </template>
                            </Column>
                            <Column field="site" header="Site" :sortable="true">

                                <template #body="slotProps">
                                    {{ slotProps.data.site }}
                                </template>
                            </Column>
                        </DataTable>

                        <!-- <Paginator v-if="user.data.role.permissionLevel < 10" :rows="limit" :totalRecords="APICallback.logs.logsCount"
                            @page="updatePage"></Paginator>
                        <Paginator v-else :rows="limit" :totalRecords="APICallback.logs.logsCount" @page="updatePage"></Paginator> -->
                    </AccordionTab>
                </Accordion>
            </div>
        </div>
        <Dialog header="Confirmation" :visible.sync="triggerExportPopup" :style="{ width: '350px' }" :modal="true" :closable="false">
            <div class="confirmation-content">
                <span>Are you sure you want to export these fields?</span>
            </div>

            <template #footer>
                <Button label="No" icon="pi pi-times" @click="exportCSV(false)" class="p-button-text" />
                <Button v-if="!exportLoading" label="Yes" icon="pi pi-check" @click="exportCSV(true)" class="p-button-text" autofocus />
                <Button v-else label="Yes" icon="pi-spin pi pi-spinner" @click="exportCSV(true)" class="p-button-text" disabled autofocus />
            </template>
        </Dialog>

        <Dialog :header="'Select Export Format'" :modal="true" :visible.sync="sendReportVisible" class="send_report__dialog">
            <div id="report__format" class="built_in_report__format">
                <span>Format Required:</span>
                <div>
                    <RadioButton id="reportFormatCSV" name="reportFormatCSV" value="csv" v-model="reportFormat"></RadioButton>
                    <label for="reportFormatCSV">CSV</label>
                </div>
                <div>
                    <RadioButton id="reportFormatPDF" name="reportFormatPDF" value="pdf" v-model="reportFormat"></RadioButton>
                    <label for="reportFormatPDF">PDF</label>
                </div>
                <div>
                    <RadioButton id="reportFormatExcel" name="reportFormatExcel" value="xlxs" v-model="reportFormat"></RadioButton>
                    <label for="reportFormatExcel">Excel</label>
                </div>
            </div>
            <!-- <div id="report__emails" class="built_in_report__emails">
                <div>
                    <label for="emailMain">Send to:</label>
                    <Chips name="emailMain" v-model="emailMain" separator="," addOnBlur />
                </div>

                <div>
                    <label for="emailCC">CC:</label>
                    <Chips name="emailCC" v-model="emailCC" separator="," addOnBlur />
                </div>
            </div> -->
            <Button type="button" class="p-button" label="Download Report" @click.prevent="sendBuiltInReport" :icon="loading ? 'pi pi-spin pi-spinner' : ''" iconPos="right" :disabled="loading" />
        </Dialog>

        <Toast />
    </div>
</template>

<script>
import moment from 'moment';
import { mapGetters } from "vuex";
import axios from 'axios';
import { FilterMatchMode } from 'primevue/api';
import { db } from '@/firebase'
import { auth } from "@/firebase";
import { getAuth } from "firebase/auth";
import store from "@/stores/store";


export default {
    data() {
        return {
            loading: false,
            limit: 50,
            logs: [],
            logsCount: 0,
            pages: [],
            client: [],
            filters: { global: { value: null, matchMode: FilterMatchMode.CONTAINS } },
            siteCount: [],
            userCount: [],
            attendanceData: [],
            assetBatchCount: [],
            maintenanceStatuses: {},
            currentTime: moment().unix(),
            siteNames: [],
            // data objects for graphs below
            selectedSites: [],
            statusChart: null,
            locationAttendanceChart: null,
            LocationAttendanceScheduleChart: null,
            warrantyChart: null,
            frequencyChart: null,
            lifecycleChart: null,
            faultChart: null,
            assetCountMaintenance: 0,
            assetCountAttendance: 0,
            assetCountWarranty: 0,
            assetCountFrequency: 0,
            assetCountLifecycle: 0,
            faultCount: 0,
            //asset key storage for each chart
            lifecycleAssets: [],
            frequencyAssets: [],
            warrantyAssets: [],
            maintenanceAssets: [],
            LocationAttendanceScheduleData: [],
            faultData: [],
            attendanceLocations: [],
            documentArray: [],
            triggerExportPopup: false,
            sendReportVisible: false,
            reportFormat: 'csv',
            APICallback: {
                logs: [],
                sites: [],
                users: [],
                client: [],
                assets: [],
                attendanceData: [],
                faultData: []
            },
            exportLoading: false,
            selectedExport: null,
            loader: true,
            faultLoader: true,
        }
    },
    computed: {
        // map `this.user` to `this.$store.getters.user`
        ...mapGetters({
            user: "user"
        }),

        CancelToken() { // for cancelling pending axios requests for graphs
            const CancelToken = axios.CancelToken
            const cancelTokenSource = CancelToken.source()
            return cancelTokenSource;
        }
    },
    created() {
        this.initDashboard();
        this.updatePage({ page: 0 });
    },
    // firestore() {
    //     return {
    //         client: db.collection('clients').doc(this.user.data.client.key),
    //         sites: db.collection('sites').where('client_id', '==', this.user.data.client.key).orderBy('timestamp', 'desc').limit(5),
    //         users: db.collection('users').where('client.key', '==', this.user.data.client.key).orderBy('timestamp', 'desc').limit(5),
    //         attendanceData: db.collection('attendance').where('client_id', '==', this.user.data.client.key).where('checked.key', '!=', false).orderBy('checked.key', 'desc').orderBy('timestamp', 'desc'),
    //     }

    // },
    beforeRouteLeave(to, from, next) {
        this.CancelToken.cancel('graph request cancelled')
        next();
    },
    methods: {
        getExport(exportType) {
            this.loading = true;
            const requestUrl = `${process.env.VUE_APP_API_URL}/export/${exportType}`
            const sitesArg = this.selectedSites.map((site) => site.key).join(",");
            axios({
                method: 'get',
                url: requestUrl,
                params: {
                    clientId: this.user.data.client.key,
                    selectedSites: sitesArg
                }
            }).then((response) => {
                if (response.data.message) { // message only shows if error thrown in promise in API
                    this.$toast.add({ severity: 'error', summary: 'Error', detail: response.data.message, life: 3000 })
                } else { // if no message, successful download
                    const anchor = document.createElement('a');
                    anchor.href = response.data.URL;
                    anchor.setAttribute('download', response.data.URL);
                    document.body.appendChild(anchor);
                    anchor.click();
                    document.body.removeChild(anchor);
                }
                this.loading = false;
            }).catch(error => {
                this.$toast.add({ severity: 'error', summary: 'Error', detail: error, life: 3000 })
                this.loading = false;
            })
        },

        handleApiError() {

        },

        triggerStatusGraph(elementId, assetType, statusCategories, chartTitle, colorScheme, dataProcessor) {
            const element = document.getElementById(elementId);
            const statusCounts = statusCategories.map(() => []);
            const assetIds = [];

            this.APICallback.assets.forEach(asset => {
                if (dataProcessor(asset, statusCounts)) {
                    assetIds.push(asset.id);
                }
            });

            // Clean up and initialize the chart
            if (this[elementId + 'Chart']) {
                this[elementId + 'Chart'].destroy();
            }

            this[elementId + 'Chart'] = this.graphTemplate(
                element,
                statusCategories,
                chartTitle,
                statusCounts.map(category => category.length),
                colorScheme
            );

            return assetIds;
        },


        initGraphs() {
            this.loader = true;
            this.faultLoader = true;

            const graphRequests = [
                this.fetchData('/dashboard/init/graph').then(data => {
                    this.APICallback.assets = data;
                    this.triggerMaintenanceStatusGraph();
                    this.triggerLocationAttendanceSchedule();
                    this.triggerAssetLocationMaintenanceStatus();
                    this.triggerWarrantyStatusGraph();
                    this.triggerLifecycleGraph();
                    this.loader = false;
                }).catch(error => {
                    console.error(error);
                }),
                this.fetchData('/dashboard/init/faults-graph').then(data => {
                    this.APICallback.faultData = data;
                    this.triggerFaultStatusGraph();
                    this.faultLoader = false
                }).catch(error => {
                    console.error(error)
                })
            ];

            Promise.all(graphRequests)
                .then(() => {
                    this.faultLoader = false;
                    this.loader = false;
                })
                .catch(error => {
                    console.error("An error occurred while fetching API data:", error);
                });
        },


        fetchData(endpoint) {
            return axios({
                method: 'post',
                url: `${process.env.VUE_APP_API_URL}${endpoint}`,
                headers: {
                    'Authorization': `Bearer ${this.user.auth.accessToken}`
                },
                data: {
                    'client': this.user.data.client.key,
                    'selectedSites': this.selectedSites.map((site) => site.key).join(",")
                }
            }).then(response => response.data)
                .catch(error => {
                    this.handleApiError();
                    throw error;
                })
        },

        initDashboard() {

            const sitesUrl = process.env.VUE_APP_API_URL + '/dashboard/init/sites',
                clientUrl = process.env.VUE_APP_API_URL + '/dashboard/init/client',
                graphUrl = process.env.VUE_APP_API_URL + '/dashboard/init/graph',
                faultsGraphUrl = process.env.VUE_APP_API_URL + '/dashboard/init/faults-graph',
                attendanceUrl = process.env.VUE_APP_API_URL + '/dashboard/init/attendance',
                usersUrl = process.env.VUE_APP_API_URL + '/dashboard/init/users';

            axios({
                method: 'post',
                url: sitesUrl,
                headers: {
                    'Authorization': `Bearer ${this.user.auth.accessToken}`
                },
                data: {
                    'client': this.user.data.client.key
                }
            }).then((response) => {
                this.APICallback.sites = response.data;
            }).catch(error => {
                this.handleApiError();
            });

            axios({
                method: 'post',
                url: clientUrl,
                headers: {
                    'Authorization': `Bearer ${this.user.auth.accessToken}`
                },
                data: {
                    'client': this.user.data.client.key
                }
            }).then((response) => {
                this.APICallback.client = response.data;
            }).catch(error => { this.handleApiError(); });

            axios({
                method: 'post',
                url: usersUrl,
                headers: {
                    'Authorization': `Bearer ${this.user.auth.accessToken}`
                },
                data: {
                    'client': this.user.data.client.key
                }
            }).then((response) => {
                this.APICallback.users = response.data;
            }).catch(error => { this.handleApiError(); });

            axios({
                method: 'post',
                url: attendanceUrl,
                headers: {
                    'Authorization': `Bearer ${this.user.auth.accessToken}`
                },
                data: {
                    'client': this.user.data.client.key
                }
            }).then((response) => {
                this.APICallback.attendanceData = response.data;

            }).catch(error => { this.handleApiError(); });

            this.initGraphs();

        },
        format_date(value) {
            if (value) {
                return moment(value).format('DD/MM/YYYY @ hh:mma')
            }
        },
        async updatePage(e) {
            const logsUrl = process.env.VUE_APP_API_URL + '/dashboard/init/logs';
            axios({
                method: 'post',
                url: logsUrl,
                headers: {
                    'Authorization': `Bearer ${this.user.auth.accessToken}`
                },
                data: {
                    'client': this.user.data.client.key,
                    'pages': this.pages,
                    'e': e,
                    'start': this.pages[e.page] != undefined ? this.pages[e.page].timestamp : 0,
                    'permissionLevel': this.$store.getters.user.data.role.permissionLevel,
                    'limit': this.limit,
                    'logs': this.logs
                }
            }).then((response) => {
                this.APICallback.logs = response.data;
                this.logs = response.data.logsArray;
                // console.log(this.logs)
            }).catch(error => { console.error(error) });
        },
        graphTemplate(
            element,
            dataLabels,
            datasetLabel,
            dataset,
            datasetColours
        ) {
            const chart = new Chart(element, {
                type: 'doughnut',
                data: {
                    labels: dataLabels,
                    datasets: [{
                        label: datasetLabel,
                        data: dataset,
                        backgroundColor: datasetColours
                    }]
                },
                options: {
                    onClick: (e) => {
                        const points = chart.getElementsAtEventForMode(e, 'nearest', { intersect: true }, true);

                        if (points.length) {
                            const firstPoint = points[0];
                            let label = chart.data.labels[firstPoint.index];
                            label = label.replace(/ /g, "_").toLowerCase();
                            this.$cookie.set('dashChartId', element.id, { expires: '0' });
                            this.$cookie.set('dashChartValue', label, { expires: '0' });
                        }

                    }
                }
            });
            return chart;
        },
        reportFault() {
            // window.open('/asset-search', '_blank', 'popup');
        },
        grabCSVData(assetIDs) {
            this.triggerExportPopup = true;
            this.exportLoading = true;
            if (this.selectedSites.length) { // if sites have been selected from dropdown, 
                axios({
                    method: 'post',
                    url: process.env.VUE_APP_API_URL + '/dashboard/export/selected-sites',
                    headers: {
                        'Authorization': `Bearer ${this.user.auth.accessToken}`
                    },
                    data: {
                        'selectedSites': this.selectedSites
                    }
                }).then((response) => {
                    this.documentArray = response.data; // data = all assets within selected sites
                    this.exportLoading = false;

                    // this.documentArray.forEach((doc, index) => {
                    //     // console.log(doc.maintenance_current_notes)
                    //     axios({
                    //         method: 'post',
                    //         url: process.env.VUE_APP_API_URL + '/dashboard/export/sites',
                    //         data: {
                    //             'site': doc.site_id
                    //         }
                    //     }).then((response) => {
                    //         this.documentArray[index].site_name = response.data;
                    //         this.exportLoading = false;
                    //     }).catch(error => { console.error(error) });
                    // })

                }).catch(error => { console.error(error) });
            } else { // otherwise, get all assets based on the client id
                axios({
                    method: 'post',
                    url: process.env.VUE_APP_API_URL + '/dashboard/export',
                    headers: {
                        'Authorization': `Bearer ${this.user.auth.accessToken}`
                    },
                    data: {
                        'clientId': this.user.data.client.key
                    }
                }).then((response) => {
                    this.documentArray = response.data;
                    this.exportLoading = false;

                    // this.documentArray.forEach((doc, index) => {
                    //     // console.log(doc.maintenance_current_notes)
                    //     axios({
                    //         method: 'post',
                    //         url: process.env.VUE_APP_API_URL + '/dashboard/export/sites',
                    //         data: {
                    //             'site': doc.site_id
                    //         }
                    //     }).then((response) => {
                    //         this.documentArray[index].site_name = response.data; // data = all assets under client id
                    //         this.exportLoading = false;
                    //     }).catch(error => { console.error(error) });
                    // })

                }).catch(error => { console.error(error) });
            }

        },
        exportCSV(confirm) {
            if (confirm) {

                axios({
                    method: 'post',
                    url: process.env.VUE_APP_API_URL + '/export/page/dashboard/csv',
                    headers: {
                        'Authorization': `Bearer ${this.user.auth.accessToken}`
                    },
                    data: {
                        'selectedExport': this.selectedExport,
                        'documentArray': this.documentArray,
                        'clientId': this.APICallback.client.key
                    }
                }).then((response) => {
                    if (response.data.message) { // message only shows if error thrown in promise in API
                        this.$toast.add({ severity: 'error', summary: 'Error', detail: response.data.message, life: 3000 })
                    } else { // if no message, successful download
                        const anchor = document.createElement('a');
                        anchor.href = response.data.URL;
                        anchor.target = '_blank';
                        anchor.click();
                    }

                }).catch(error => { console.error(error) });
            }
            this.documentArray = [];
            this.triggerExportPopup = false;
        },

        triggerMaintenanceStatusGraph() {

            const AssetMaintenanceStatus = document.getElementById('AssetMaintenanceStatus'); // element to write new chart to

            let okAssets = [],
                warningAssets = [],
                overdueAssets = [],
                neverMaintained = [];

            this.APICallback.assets.forEach(asset => { // foreach asset, loop through the selected sites, if site key == this site_id, push to new data array
                let id = asset.id;


                if (asset.asset_type == 'Asset') {
                    if (asset.maintenance_frequency != null) {
                        if (asset.maintenance_status) {
                            if (asset.maintenance_status.asset_page_label == 'OK') {
                                okAssets.push(id)
                            }
                            if (asset.maintenance_status.asset_page_label == 'Warning') {
                                warningAssets.push(id)
                            }

                            if (asset.maintenance_status.asset_page_label == 'Overdue') {
                                overdueAssets.push(id)
                            }

                            if (asset.maintenance_status.asset_page_label == '') {
                                neverMaintained.push(id)
                            }
                        } else {
                            neverMaintained.push(id) // this is most likley temp
                        }
                    }
                }

                this.maintenanceAssets.push(id);

            });


            if (this.statusChart) {
                this.statusChart.destroy();
            }

            this.statusChart = this.graphTemplate(AssetMaintenanceStatus,
                ['OK', 'Warning', 'Overdue', 'Never Maintained'],
                'Assets',
                [okAssets.length, warningAssets.length, overdueAssets.length, neverMaintained.length],
                ['#4bb543', '#ffbf00', '#f31b2b', 'grey']
            )

        },

        triggerLocationAttendanceSchedule() {
            const LocationAttendanceSchedule = document.getElementById('LocationAttendanceSchedule'); // element to write new chart to

            let okLocations = [],
                warningLocations = [],
                overdueLocations = [],
                neverAttended = [];

            this.APICallback.assets.forEach(asset => { // foreach asset, loop through the selected sites, if site key == this site_id, push to new data array
                let id = asset.id;


                if (asset.asset_type == 'Location') {
                    if (asset.maintenance_frequency != null) {
                        if (asset.maintenance_status) {
                            if (asset.maintenance_status.asset_page_label == 'OK') {
                                okLocations.push(id)
                            }
                            if (asset.maintenance_status.asset_page_label == 'Warning') {
                                warningLocations.push(id)
                            }
                            if (asset.maintenance_status.asset_page_label == 'Overdue') {
                                overdueLocations.push(id)
                            }
                            if (asset.maintenance_status.asset_page_label == '') {
                                neverAttended.push(id)
                            }
                        } else {
                            neverAttended.push(id) // this is most likley tem
                        }
                    }
                }

                this.LocationAttendanceScheduleData.push(id);
            });

            if (this.LocationAttendanceScheduleChart) {
                this.LocationAttendanceScheduleChart.destroy();
            }

            this.LocationAttendanceScheduleChart = this.graphTemplate(LocationAttendanceSchedule,
                ['OK', 'Warning', 'Overdue', 'Never Attended'],
                'Locations',
                [okLocations.length, warningLocations.length, overdueLocations.length, neverAttended.length],
                ['#4bb543', '#ffbf00', '#f31b2b', 'grey']
            )
        },

        triggerAssetLocationMaintenanceStatus() {
            const AssetLocationMaintenanceStatus = document.getElementById('AssetLocationMaintenanceStatus');

            let passAssets = [],
                failedAssets = [],
                neverAssets = [];

            this.APICallback.assets.forEach(asset => { // foreach asset, loop through the selected sites, if site key == this site_id, push to new data array
                let id = asset.id;

                if (asset.asset_type == 'Asset' || asset.asset_type == 'Location') {
                    if (asset.maintenance_frequency != null) {
                        if (asset.maintenance_current_status) {
                            if (asset.maintenance_current_status == 'Pass') {
                                passAssets.push(id)
                            }
                            if (asset.maintenance_current_status == 'Fail') {
                                failedAssets.push(id)
                            }
                        } else {
                            neverAssets.push(id) // this is most likley tem
                        }
                    }
                }

            });

            if (this.AssetLocationMaintenanceStatusChart) {
                this.AssetLocationMaintenanceStatusChart.destroy();
            }

            this.AssetLocationMaintenanceStatusChart = this.graphTemplate(AssetLocationMaintenanceStatus,
                ['Pass', 'Failed', 'Never Maintained / Attended'],
                'Assets/Locations',
                [passAssets.length, failedAssets.length, neverAssets.length],
                ['#4bb543', '#f31b2b', 'grey']
            )

        },

        triggerWarrantyStatusGraph() {

            const AssetWarrantyStatus = document.getElementById('AssetWarrantyStatus');

            let withinWarranty = [],
                withinThreshold = [],
                expired = [],
                noWarranty = [];

            this.APICallback.assets.forEach(asset => { // foreach asset, loop through the selected sites, if site key == this site_id, push to new data array
                let id = asset.id;


                if (asset.asset_type == 'Asset') {

                    if (asset.warranty_expiry_date) {
                        let warrantyDueDate = moment.utc(asset.warranty_expiry_date._seconds * 1000);
                        const warrantyWarningValue = asset.warranty_warning && asset.warranty_warning.value
                            ? asset.warranty_warning.value
                            : 0;

                        // warranty statements
                        if (this.currentTime > warrantyDueDate.unix()) {
                            // red status
                            expired.push(id);
                        } else if ((warrantyDueDate.unix() - warrantyWarningValue) < this.currentTime && this.currentTime < warrantyDueDate.unix()) {
                            // amber status
                            withinThreshold.push(id);
                        } else {
                            // green status
                            withinWarranty.push(id);
                        }

                    } else {
                        noWarranty.push(id);
                    }

                }

                this.warrantyAssets.push(id);
            });


            this.assetCountWarranty = this.warrantyAssets.length;
            this.warrantyAssets = [];

            if (this.warrantyChart) {
                this.warrantyChart.destroy();
            }

            this.warrantyChart = this.graphTemplate(
                AssetWarrantyStatus,
                ['In Warranty', 'Warning', 'Out of Warranty', 'No Warranty'],
                'Assets',
                [withinWarranty.length, withinThreshold.length, expired.length, noWarranty.length],
                ['#4bb543', '#ffbf00', '#f31b2b', 'grey']
            )

        },

        triggerLifecycleGraph() {
            const AssetLifecycle = document.getElementById('AssetLifecycle');

            let withinLifecycle = [],
                withinThreshold = [],
                expired = [],
                noLifecycle = [],
                totalAssets = [];

            this.APICallback.assets.forEach(asset => { // foreach asset, loop through the selected sites, if site key == this site_id, push to new data array
                let id = asset.id;


                if (asset.asset_type == 'Asset') {
                    if (asset.lifecycle_expiry_date) {
                        let lifecycleDueDate = moment.utc(asset.lifecycle_expiry_date._seconds * 1000);
                        if (asset.lifecycle_warning) {
                            // lifecycle statements
                            if (this.currentTime > lifecycleDueDate.unix()) {
                                // red status
                                expired.push(id);

                            } else if ((lifecycleDueDate.unix() - asset.lifecycle_warning.value) < this.currentTime && this.currentTime < lifecycleDueDate.unix()) {
                                // amber status
                                withinThreshold.push(id);
                            } else if (this.currentTime < (lifecycleDueDate.unix() - asset.lifecycle_warning.value)) {
                                // green status
                                withinLifecycle.push(id);
                            }
                        } else {
                            // lifecycle statements
                            if (this.currentTime > lifecycleDueDate.unix()) {
                                // red status
                                expired.push(id);
                            } else {
                                // green status
                                withinLifecycle.push(id);
                            }
                        }

                    } else {
                        noLifecycle.push(id);
                    }
                }

                this.lifecycleAssets.push(id);
            });

            this.assetCountLifecycle = this.APICallback.assets.length;

            if (this.lifecycleChart) {
                this.lifecycleChart.destroy();
            }

            this.lifecycleChart = this.graphTemplate(
                AssetLifecycle,
                ['OK', 'Warning', 'Expired', 'No Lifecycle'],
                'Asset Lifecycle',
                [withinLifecycle.length, withinThreshold.length, expired.length, noLifecycle.length],
                ['#4bb543', '#ffbf00', '#f31b2b', 'grey']
            )

        },

        triggerLocationStatusGraph(update, newData) {

            const LocationAttendanceStatus = document.getElementById('LocationAttendanceStatus'); // element to write new chart to

            let passedAssets = [],
                failedAssets = [],
                faultAssets = [],
                neverMaintained = [],
                newKeys = [],
                newDataArray = [];

            this.APICallback.assets.forEach(asset => { // foreach asset, loop through the selected sites, if site key == this site_id, push to new data array
                let value = asset.maintenance_current_status,
                    id = asset.id;

                if (update && newData.length) { // if sites have been selected from the select box i.e. not on page load
                    // console.log(asset);

                    newData.forEach(data => {
                        if ((asset.site_id == data.key) && asset.asset_type == 'Location') {
                            newDataArray.push(asset.maintenance_current_status);
                            newKeys.push(asset.id)
                        }
                    })

                } else {

                    if (asset.asset_type == 'Location') {
                        if (value) {
                            // console.log(asset.asset_type)
                            if (value == 'Pass') {
                                passedAssets.push(id)
                            }
                            if (value == 'Fail') {
                                failedAssets.push(id)
                            }
                            if (value == 'Fault') {
                                faultAssets.push(id)
                            }
                        } else {
                            neverMaintained.push(id) // this is most likley temp
                        }
                    }

                    this.attendanceLocations.push(id);

                }
            });

            if (update && newData.length) { // if sites have been selected from the select box i.e. not on page load


                this.assetCountAttendance = newDataArray.length;
                this.attendanceLocations = [];

                newDataArray.forEach((value, index) => {

                    if (value) {
                        if (value == 'Pass') {
                            passedAssets.push(newKeys[index])
                        }
                        if (value == 'Fail') {
                            failedAssets.push(newKeys[index])
                        }
                        if (value == 'Fault') {
                            faultAssets.push(newKeys[index])
                        }
                    } else {
                        neverMaintained.push(newKeys[index]) // this is most likley temp
                    }

                    this.attendanceLocations.push(newKeys[index]);

                })

                if (this.locationAttendanceChart) {
                    this.locationAttendanceChart.destroy();
                }

                this.locationAttendanceChart = this.graphTemplate(LocationAttendanceStatus,
                    ['Passed', 'Failed', 'Never Attended'],
                    'Locations',
                    [passedAssets.length, failedAssets.length, neverMaintained.length],
                    ['#4bb543', '#f31b2b', 'grey']
                )

            } else {

                this.assetCountAttendance = this.APICallback.assets.length;

                if (this.locationAttendanceChart) {
                    this.locationAttendanceChart.destroy();
                }

                this.locationAttendanceChart = this.graphTemplate(LocationAttendanceStatus,
                    ['Passed', 'Failed', 'Never Attended'],
                    'Locations',
                    [passedAssets.length, failedAssets.length, neverMaintained.length],
                    ['#4bb543', '#f31b2b', 'grey']
                )

            }

        },
        triggerFaultStatusGraph() {

            const FaultStatus = document.getElementById('FaultStatus');

            let activeFault = [],
                inProgressFault = [],
                rectifiedFault = [],
                noFault = [];
            this.APICallback.faultData.forEach(fault => { // foreach asset, loop through the selected sites, if site key == this site_id, push to new data array
                let id = fault.id;

                switch (fault.fault_status) {
                    case 'active':
                        activeFault.push(id)
                        break;
                    case 'in_progress':
                        inProgressFault.push(id)
                        break;
                    case 'rectified':
                        rectifiedFault.push(id)
                        break;
                }
                this.faultData.push(id);
            });

            this.faultCount = this.APICallback.faultData.length;

            if (this.faultChart) {
                this.faultChart.destroy();
            }

            this.faultChart = this.graphTemplate(
                FaultStatus,
                ['Active Fault', 'Fault In Progress', 'Fault Rectified'],
                'Faults',
                [activeFault.length, inProgressFault.length, rectifiedFault.length],
                ['#f31b2b', '#ffbf00', '#1f5ea4']
            )
        },


        async sendBuiltInReport() {
            let requestUrl
            const sites = (this.selectedSites.length) ? this.selectedSites.map(site => site.key).join(",") : this.APICallback.sites.map(site => site.key).join(",")

            this.loading = true



            switch (this.reportFormat) {
                case 'pdf':
                    requestUrl = `${process.env.VUE_APP_API_URL}/export/pdf/${this.selectedExport}`
                    break;
                default:
                    requestUrl = `${process.env.VUE_APP_API_URL}/export/${this.selectedExport}`
                    break;
            }

            axios({
                method: 'get',
                url: requestUrl,
                params: {
                    clientId: this.APICallback.client.key,
                    selectedSites: sites,
                    isExcel: this.reportFormat === 'xlxs'
                }
            }).then((response) => {

                db.collection('logs').add({
                    activity: 'New Built-in Report Generated: ' + this.selectedExport,
                    timestamp: new Date(),
                    user: this.user.data.email,
                    client_id: this.user.data.client.key
                }).then(() => {
                    if (this.reportFormat === 'pdf') {
                        // Open PDF in new tab
                        window.open(response.data.URL, '_blank');
                    } else {
                        // Handle CSV download
                        if (response.data.message) {
                            this.$toast.add({ severity: 'error', summary: 'Error', detail: response.data.message, life: 3000 })
                        } else {
                            const anchor = document.createElement('a');
                            anchor.href = response.data.URL;
                            anchor.setAttribute('download', response.data.URL);
                            document.body.appendChild(anchor);
                            anchor.click();
                            document.body.removeChild(anchor);
                        }
                    }
                    this.loading = false;
                    this.sendReportVisible = false
                    if (!response.data.message) {
                        this.$toast.add({ severity: 'success', summary: 'Success', detail: 'Report created successfully', life: 3000 })
                    }
                });
            }).catch(error => {
                console.log(error)
                this.$toast.add({ severity: 'error', summary: 'Error', detail: error, life: 3000 })
                this.loading = false;
            })

        },
    }
}
</script>

<style lang="scss">
.loader_wrapper {
    width: calc(100% - 42px);
    height: 200px;
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
}
</style>